// EnergyTwitter.tsx
import React, { useEffect, useState, useRef } from "react";
import EnergyTweet from "./EnergyTweet";
import { Virtuoso, VirtuosoHandle } from "react-virtuoso";

interface TweetType {
  tweet_id: string;
  text: string;
  created_at: string;
  username: string;
  name: string;
  isNew?: boolean;
}

const MAX_TWEETS = 50;

const EnergyTwitter: React.FC = () => {
    const items = [
    { time: "12:39", title: "The Fly: TD Synnex price target raised to $160 from $150 at Loop Capital" },
    { time: "12:38", title: "CGTNEurope: IRAN MINISTRY OF ROADS AND URBAN DEVELOPMENT SPOKESPERSON SAYS IRAN'S WESTERN AND CENTRAL AIRSPACE IS OPEN ONLY TO INTERNATIONAL TRANSIT FLIGHTS - TASMIN" },
    { time: "12:38", title: "The Fly: Pegasystems price target raised to $60 from $52.50 at Loop Capital" },
    { time: "12:37", title: "Benzinga News: Sonim Technologies Issues Update On Proposed Reverse Takeover With Nvidia-Based High-Performance Computing AI Factories" },
    { time: "12:37", title: "Benzinga News: SunCar Technology Expands Strategic Partnership With Xiaomi To Power Fully Intelligent Auto Insurance For YU7" },
    { time: "12:37", title: "The Fly: Seaport starts Chime with a Buy, sees 'right recipe' for growth" },
    { time: "12:36", title: "The Fly: Diginex announces more government funding support for compliance solutions" },
    { time: "12:36", title: "Benzinga News: Abeona Therapeutics Added To Russell 2000 And Russell 3000 Indexes Following ZEVASKYN FDA Approval" },
    { time: "12:36", title: "Benzinga News: BridgeBio Sells Portion Of Royalties From BEYONTRA Sales In Europe To Blue Owl Capital For $300M" },
    { time: "12:37", title: "The Fly: Seaport starts Chime with a Buy, sees 'right recipe' for growth" },
    { time: "12:36", title: "The Fly: Diginex announces more government funding support for compliance solutions" },
    { time: "12:36", title: "Benzinga News: Abeona Therapeutics Added To Russell 2000 And Russell 3000 Indexes Following ZEVASKYN FDA Approval" },
    { time: "12:36", title: "Benzinga News: BridgeBio Sells Portion Of Royalties From BEYONTRA Sales In Europe To Blue Owl Capital For $300M" }
  ];

  return (
    <div className="h-full flex flex-col relative bg-gray-900">
      {/* Banner below widget header */}
      <div className="bg-squawk-blue text-white text-center text-sm font-medium py-2 ">
        <div className="animate-pulse">Subscribe here for real-time service</div>
      </div>

      {/* Content area without blur */}
      <div className="flex-1 overflow-auto">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-center justify-between px-4 py-2 border-b border-gray-700 text-xs text-gray-300">
            <span className="whitespace-nowrap mr-2">{item.time}</span>
            <span className="flex-1 truncate">{item.title}</span>
            <span className="ml-2">↓</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EnergyTwitter;
